// @flow

import React from 'react';
import ListPage from 'esm-web-pro/containers/pages/ListPage';
import { Trash } from 'grommet-icons';
import {
    defineMessages, FormattedMessage, injectIntl, IntlShape,
} from 'react-intl';
import { Route } from 'react-router';
import ActionsColumn from 'speed-js-react-web/src/components/grommet2/tables/columns/Action/ActionsColumn';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import DateTimeColumn from 'speed-js-react-web/src/components/grommet2/tables/columns/DateTimeColumn';

type Props = {
    intl: IntlShape,
}

const messages = defineMessages({
    locks: {
        id: 'locks-locks',
        defaultMessage: 'Locks',
    },
});

const LocksRoutes = (scopeProps: Props) => {
    const { intl: { formatMessage } } = scopeProps;

    return (
        <>
            <Route
                path="/administration/locks/object"
                render={(props) => (
                    <ListPage
                        {...props}
                        resourceName="objectLocks"
                        title={formatMessage(messages.locks)}
                        permissions={['locks.view_objectlock']}
                        columns={[
                            {
                                Header: <FormattedMessage
                                    id="locks-object"
                                    defaultMessage="Object"
                                />,
                                accessor: 'object.name',
                            },
                            {
                                Header: <FormattedMessage id="locks-object-type" defaultMessage="Type" />,
                                accessor: 'object.object_type',
                            },
                            {
                                Header: <FormattedMessage id="locks-user" defaultMessage="User" />,
                                accessor: 'user.username',
                            },
                            {
                                Header: <FormattedMessage id="locks-ap-address" defaultMessage="IP Address" />,
                                accessor: 'ip_address',
                            },
                            {
                                Header: <FormattedMessage
                                    id="address-coverage-created-on"
                                    defaultMessage="Created on"
                                />,
                                accessor: 'created',
                                Cell: DateTimeColumn,
                            },
                            {
                                Header: <FormattedMessage id="locks-last-active" defaultMessage="Last active" />,
                                accessor: 'modified',
                                Cell: DateTimeColumn,
                            },
                            {
                                actions: [{
                                    label: formatMessage(actionMessages.delete),
                                    resourceName: 'objectLocks',
                                    accessor: 'uuid',
                                    type: 'delete',
                                    icon: <Trash />,
                                    nameAccessor: 'object.name',
                                }],
                                Cell: ActionsColumn,
                                maxWidth: 110,
                            },

                        ]}
                    />
                )}
            />
        </>
    );
};

export default injectIntl(LocksRoutes);
